import React, { Component } from 'react';
import { Table } from 'reactstrap';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../../api-config';
import { auth } from '../../../../../../services/auth.service';
import { TransactionListLoader } from './TransactionListLoader';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import IsLoading from '../../../../../Shared/Loading/IsLoading';
import GridDateTimeFormatter from '../../../../GridDateTimeFormatter';
import '../ManageBatches.scss';

const FileDownload = require('js-file-download');

class TransactionList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			batchInEdit: this.props.dataItem || null,
			transactionList: [],
			isLoading: true,
			isSubmitted: false,
			transactions: { data: [], total: 0 },
			dataState: {
				take: 10,
				skip: 0,
				filter: {
					logic: "and",
					filters: [{ field: "BatchJobId", operator: "eq", value: this.props.dataItem.BatchJobId }]
				},
				sort: [{ field: "CreateDate", dir: "desc" }]
			},
		};
	}

	formatDate = (date) => {
		let d = date.split('-');
		return d[1] + "-" + d[2].substring(0, 2) + "-" + d[0];
	}

	dataRecieved = (transactionsFetched) => {
		this.setState({
			...this.state,
			transactions: transactionsFetched,
			isLoading: false
		});
	}

	dataStateChange = (e) => {
		this.setState({
			...this.state,
			dataState: e.data
		});
	}

	stringifyObj = (arr) => {
		let t = [...arr];
		if (!t) {
			return null;
		}
		else {
			for (var i = 0; i < t.length; i++) {
				var element = { ...t[i] };
				if (element["field"] === "BatchDate" || element["field"] === "BatchStart" || element["field"] === "BatchEnd") {
					let date = element.value;
					if (!date) {
						date = "01/01/0001";
					}
					else {
						date = (date + '').split(" ");
						let day = date[2] + '';
						let year = date[3] + '';
						let month = "01";
						switch (date[1]) {
							case "Jan":
								month = "01";
								break;
							case "Feb":
								month = "02";
								break;
							case "Mar":
								month = "03";
								break;
							case "Apr":
								month = "04";
								break;
							case "May":
								month = "05";
								break;
							case "Jun":
								month = "06";
								break;
							case "Jul":
								month = "07";
								break;
							case "Aug":
								month = "08";
								break;
							case "Sep":
								month = "09";
								break;
							case "Oct":
								month = "10";
								break;
							case "Nov":
								month = "11";
								break;
							case "Dec":
								month = "12";
								break;
						}
						date = month + "/" + day + "/" + year;
						element["value"] = date;
					}
				}
				else {
					for (var key in t[i]) {
						element[key] = element[key] + '';
					}
				}
				t[i] = element;
			}
			return t;
		}
	}

	exportToExcel = () => {
		var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
		var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
		var KendoGridQuery = {
			Filters: Filters ? Filters.slice() : [],
			Sorts: Sorts ? Sorts.slice() : []
		}

		axios.get(ROOT_API_URL + "/ManageBatches/ExportTransactionListToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
			.then((response) => {
				FileDownload(response.data, 'Transaction List.csv');
			});
	}

	render() {
		return (
			<div id="transaction-list">
				<div className="account-tab-content">
					<div>
						<div>
							<h1 className="pt-3 pb-3">Transactions List</h1>
						</div>
					</div>
				</div>
					{this.state.isLoading ?
						(<div>
							<IsLoading message="Loading transactions" />
						</div>

						) :
						(
							<div>
								<div>
									<Grid
										style={{ width: '100vw', height: '56vh' }}
										filterable={true}
										sortable={true}
										pageable={true}
										total={this.state.transactions.total}
										{...this.state.dataState}
										{...this.state.transactions}
										onDataStateChange={this.dataStateChange}
										resizable
										reorderable={true}
									>
										<GridToolbar>
											<div className="admin-grid-toolbar-box2">
												<button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
													<i className="fas fa-file-export"></i>
													EXPORT TO EXCEL
												</button>
											</div>
										</GridToolbar>
										{/* <Column field="TransactionId" title="Transaction ID" filter="text" filterable={true}/>
										<Column field="BatchJobId" title="Batch ID" filter="text" filterable={false}/>
										<Column field="Email" title="Email" filter="text" />
										<Column field="CreateDate" title="Create Date" filter="date" cell={GridDateFormatter} />
										<Column field="Amount" title="Grand Total" filter="numeric" />
										<Column field="Description" title="Payment Type" filter="text" /> */}
										<Column field="BatchNumber" title="Batch Id" filter="text" filterable={false} />
										<Column field="TransactionNumber" title="Transaction Id" filter="text" />										
										<Column field="MembershipId" title="Membership Id" filter="text" />
										<Column field="CreateDate" title="Transaction Date" cell={GridDateTimeFormatter} filter="date" />
										<Column field="Name" title="Name" filter="text" />
										<Column field="AmountForDisplay" title="Total Amount" format="{0:c2}"/>
										<Column field="Description" title="Payment Type" filter="text" />
										<Column field="Email" title="Email" filter="text" />
									</Grid>
								</div>
							</div>
							)}
				<div>
					{!this.state.isSubmitted ?
						<TransactionListLoader
							dataState={this.state.dataState}
							onDataRecieved={this.dataRecieved}
						/>
						: ""
					}
				</div>
			</div>
		);
	}
}

export default TransactionList;